class ProductManuals extends HTMLElement {
  connectedCallback() {
    this.rows = Array.from(this.querySelectorAll('.manual-row'));
    this.groups = Array.from(this.querySelectorAll('.manuals-group'));
    this.search = this.querySelector('.manuals-search');
    this.clearButton = this.querySelector('.manuals-search-clear');
    this.filters = Array.from(this.querySelectorAll('.manuals-filter'));
    this.count = this.querySelector('.manuals-count');
    this.empty = this.querySelector('.manuals-empty');

    this.query = '';
    this.category = 'all';

    this.syncCounts();

    if (this.search) {
      this.search.addEventListener('input', () => {
        this.query = this.search.value.trim().toLowerCase();
        this.clearButton?.classList.toggle('is-visible', this.query.length > 0);
        this.render();
      });
    }

    this.clearButton?.addEventListener('click', () => {
      this.search.value = '';
      this.query = '';
      this.clearButton.classList.remove('is-visible');
      this.search.focus();
      this.render();
    });

    this.filters.forEach((button) => {
      button.addEventListener('click', () => {
        this.category = button.dataset.filter;
        this.filters.forEach((other) => {
          other.setAttribute('aria-pressed', String(other === button));
        });
        this.render();
      });
    });

    this.render();
  }

  // Counts are rendered server-side from every metaobject entry, but a row is
  // only output when its PDF resolves. Recounting from the DOM keeps the
  // sidebar numbers matching the list you can actually see.
  syncCounts() {
    this.querySelectorAll('[data-count-for]').forEach((element) => {
      const key = element.dataset.countFor;
      let total;

      if (key === 'all') {
        total = this.rows.length;
      } else if (key === 'discontinued') {
        total = this.rows.filter((row) => row.dataset.discontinued === 'true').length;
      } else {
        total = this.rows.filter((row) => row.dataset.category === key).length;
      }

      element.textContent = total;
    });
  }

  matches(row) {
    if (this.query && !row.dataset.title.includes(this.query)) return false;

    if (this.category === 'all') return true;
    if (this.category === 'discontinued') return row.dataset.discontinued === 'true';

    return row.dataset.category === this.category;
  }

  render() {
    let visible = 0;

    this.rows.forEach((row) => {
      const show = this.matches(row);
      row.hidden = !show;
      if (show) visible += 1;
    });

    // A letter heading with nothing under it reads as a broken list.
    this.groups.forEach((group) => {
      const rows = Array.from(group.querySelectorAll('.manual-row'));
      group.hidden = !rows.some((row) => !row.hidden);
    });

    this.empty?.classList.toggle('is-visible', visible === 0);

    if (this.count) {
      const noun = this.rows.length === 1 ? 'manual' : 'manuals';
      this.count.textContent = `Showing ${visible} of ${this.rows.length} ${noun}`;
    }
  }
}

customElements.define('product-manuals', ProductManuals);
